import { Component, ViewChild, ViewContainerRef, ComponentFactoryResolver } from "@angular/core";

import { Observable } from 'rxjs';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import { AlertService, AlertComponent } from '../../../../../shared/alert';
import { MonthlyCut } from '../../../../../_models';
import { MonthlyCut as C } from '../../../../../_models/Classes';

@Component({
    selector: 'app-monthly-cut-list',
    templateUrl: './monthly-cut-list.component.html',
    styleUrls: ['./monthly-cut-list.component.scss']
})

export class MonthlyCutListComponent {
    enabled = {
        link: '/monthly-cuts/new',
        text: 'Nuevo corte'
    }
    tableMessages = {
        emptyMessage: 'No hay datos para mostrar',
    };
    newEntry = null;
    now: Date = new Date();
    @ViewChild('alert',
        { read: ViewContainerRef }) alertRef: ViewContainerRef;
    @BlockUI('row-update') blockUI: NgBlockUI;
    @ViewChild('successUpdate') swalUpdate: any;
    @ViewChild('fromDate') fromDate: any;
    @ViewChild('toDate') toDate: any;
    // date
    startDate: string;
    endDate: string;
    // money
    incomeFrom: number;
    incomeTo: number;
    expenseFrom: number;
    expenseTo: number;
    netIncomeFrom: number;
    netIncomeTo: number;

    constructor(
        private _cfr: ComponentFactoryResolver,
        private _alertService: AlertService,
        private data: MonthlyCut
    ) {
        this.getData();
    }
    getData() {
        this.data.getAll().subscribe(cuts => {
            this.now = new Date();
            let lastCut: C = cuts.slice(-1)[0];
            this.data.getMonthlyCutDay().subscribe(day => {
                let alreadyCut: boolean =
                    lastCut &&
                    ((this.now.getMonth() + 1) == lastCut.month && this.now.getFullYear() == lastCut.year);
                if (alreadyCut) {
                    this.showInfoAlert(`El corte de ${lastCut.monthName} 
                        ${lastCut.year} ya fue registrado`);
                    this.newEntry = null;
                }
                else if (this.now.getDate() < day) {
                    this.showInfoAlert(`El corte del mes solo se puede generar a partir del 
                        día ${day} del mes`);
                    this.newEntry = null;
                }
                else {
                    this.showInfoAlert(`Generación de corte del mes actual disponible`);
                    this.newEntry = this.enabled;
                }
            });
        });
    }
    showInfoAlert(message) {
        this.alertRef.clear();
        let factory = this._cfr.resolveComponentFactory(AlertComponent);
        let ref = this.alertRef.createComponent(factory);
        ref.changeDetectorRef.detectChanges();
        this._alertService.info(message);
    }
    updateCut(cut) {
        this.blockUI.start(`Actualizando el corte ${cut.monthName} ${cut.year}`);
        this.swalUpdate.text = `el corte ${cut.monthName} ${cut.year} fue actualizado con éxito`;
        this.data.put(cut.id).subscribe(response => {
            this.getData();
            this.swalUpdate.show();
            this.blockUI.stop();
        });
    }
    clear() {
        this.fromDate.clear();
        this.toDate.clear();
        this.startDate = null;
        this.endDate = null;
        this.incomeFrom = null;
        this.incomeTo = null;
        this.expenseFrom = null;
        this.expenseTo = null;
        this.netIncomeFrom = null;
        this.netIncomeTo = null;
        this.getData();
    }
    filter() {
        this.data.search(this.buildSearchString()).subscribe();
    }
    buildSearchString(): string {
        let searchString: string = '';
        if (this.startDate) searchString = `${searchString}&startDate=${this.startDate}`;
        if (this.endDate) searchString = `${searchString}&endDate=${this.endDate}`;
        if (this.incomeFrom) searchString = `${searchString}&incomeFrom=${this.incomeFrom}`;
        if (this.incomeTo) searchString = `${searchString}&incomeTo=${this.incomeTo}`;
        if (this.expenseFrom) searchString = `${searchString}&expenseFrom=${this.expenseFrom}`;
        if (this.expenseTo) searchString = `${searchString}&expenseTo=${this.expenseTo}`;
        if (this.netIncomeFrom) searchString = `${searchString}&netIncomeFrom=${this.netIncomeFrom}`;
        if (this.netIncomeTo) searchString = `${searchString}&netIncomeTo=${this.netIncomeTo}`;
        return searchString;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/monthly-cut/monthly-cut-list/monthly-cut-list.component.ts